/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, func, number, bool, string,
} from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useDispatch, useSelector } from 'react-redux';
import ResponsiveImage from '../../../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import style from './BYOItemsSelected.module.css';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import byoTheme from './BYOTheme';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const BYOItemsSelected = ({
    numberSelected,
    itemData,
    handleItemSelection,
    disabled,
    setSelectedOption,
    setOpen,
    error,
    handleRemoveError,
    isCYOQtyButtonEnabled,
    stepIndex,
}) => {
    useStyles(style);
    const dispatch = useDispatch();
    const brandData = useSelector(getBrand);
    const brandCode = brandData?.code;
    const [selectedFocus, setSelectedFocus] = useState(true);

    // default color assigned when no brand code found
    const {
        buttonColorSelect = '#512C1C',
    } = byoTheme[brandCode] || {};

    const handlePopup = (e, item) => {
        setSelectedOption(item);
        setOpen(e, true);
        dispatch(trackEvent({
            ga_event_name: 'byo_interaction',
            eventCategory: 'BYO',
            eventAction: 'Item popup click - open',
            eventLabel: `${item?.name  } - ${  item?.partNumber}` || '',

            interaction_type: 'select_item',
            byo_step: '',
            byo_item_name: item?.name,
            byo_item_variant: item?.partNumber,
            byo_item_quantity: '',
        }));

        dispatch(trackEvent({
            eventCategory: 'BYO – View',
            eventAction: `Add On - ${item?.name}`,
            eventLabel: item?.partNumber || '',
            eventName: 'BYO_view_add_on',
            byo_variant: item?.partNumber,
            byo_add_on_name: item?.partNumber,
        }));
    };
    const itemImagePath = itemData.image?.path?.replace(/(^\w+:|^)/, '');
    const itemImageName = itemData.image?.name;
    const imagePath = `${itemImagePath}${itemImageName}x.jpg`;
    return (
        <>

            <div>

                <div
                    role="presentation"
                    className={style.imageContainer}
                    onClick={(e) => {
                        handlePopup(e, itemData);
                    }}
                >
                    {error && (
                        <p className={style.errorContainer}>
                            {error}
                        </p>
                    )}
                    <ResponsiveImage className={style.itemImage} path={imagePath} alt={itemData.name} params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }} />
                </div>
                <div
                    style={{
                        '--btn-selected-color': buttonColorSelect,
                    }}
                >
                    {numberSelected || !selectedFocus || isCYOQtyButtonEnabled
                        ? (
                            <div
                                role="group"
                                id={` Add ${itemData?.name || 'Item'} to cart`}
                                data-testid="btn-remove"
                                className={`${style.selectedButton} ${style.numberSelectedButton} `}
                                tabIndex={-1}

                            >
                                <button
                                    type="button"
                                    data-testid="cyoDecrementButton"
                                    className={style.removeIcon}
                                    onClick={() => {
                                        handleItemSelection(-1);
                                        dispatch(trackEvent({
                                            ga_event_name: 'byo_interaction',
                                            eventCategory: 'BYO',
                                            eventAction: 'Item removed',
                                            eventLabel: itemData?.name || '',
                                            itemQuantity: numberSelected,
                                            step: stepIndex,
                                            byo_variant: itemData?.legacyId || '',

                                            interaction_type: 'remove_item',
                                            byo_step: stepIndex,
                                            byo_item_name: itemData?.name,
                                            byo_item_variant: itemData?.legacyId,
                                            byo_item_quantity: numberSelected,
                                        }));
                                    }}
                                    disabled={numberSelected === 0}
                                    aria-label={`decrease ${ReactHtmlParser(itemData?.name)}`}
                                >
                                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 13H5v-2h14v2z" /></svg>
                                </button>
                                <input
                                    type="text"
                                    name="email"
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const inputValue = e.target.value;
                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                            const diff = (parseInt(inputValue, 10) || 0) - numberSelected;
                                            handleItemSelection(diff, true);
                                        }
                                    }}
                                    onBlur={() => {
                                        handleRemoveError(itemData.legacyId);
                                        setSelectedFocus(true);
                                    }}
                                    onFocus={() => {
                                        setSelectedFocus(false);
                                    }}
                                    value={numberSelected || '0'}
                                    className={style.inputField}
                                    id={ReactHtmlParser(itemData.name)}
                                    aria-label={ReactHtmlParser(itemData?.name)}
                                />
                                <button
                                    type="button"
                                    data-testid="cyoIncrementButton"
                                    disabled={disabled}
                                    className={style.addIcon}
                                    onClick={() => {
                                        handleItemSelection(1);
                                        dispatch(trackEvent({
                                            ga_event_name: 'byo_interaction',
                                            eventCategory: 'BYO',
                                            eventAction: 'Item added',
                                            eventLabel: itemData?.name || '',
                                            itemQuantity: numberSelected,
                                            step: stepIndex,
                                            byo_variant: itemData?.legacyId || '',

                                            interaction_type: 'add_item',
                                            byo_step: stepIndex,
                                            byo_item_name: itemData?.name,
                                            byo_item_variant: itemData?.legacyId,
                                            byo_item_quantity: numberSelected,
                                        }));
                                    }}
                                    onBlur={() => {
                                        handleRemoveError(itemData.legacyId);
                                    }}
                                    aria-label={`increase ${ReactHtmlParser(itemData?.name)}`}
                                >
                                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></svg>
                                </button>
                            </div>
                        )
                        : (
                            <button
                                type="button"
                                id={` Add ${itemData?.name || 'Item'} to cart`}
                                data-testid="btn-add"
                                className={`${style.selectedButton} `}
                                tabIndex={-1}
                                onBlur={() => {
                                    handleRemoveError(itemData.legacyId);
                                }}
                                onClick={() => {
                                    handleItemSelection(1);
                                    dispatch(trackEvent({
                                        ga_event_name: 'byo_interaction',
                                        eventCategory: 'BYO',
                                        eventAction: 'Item added',
                                        eventLabel: itemData?.name || '',
                                        itemQuantity: numberSelected,
                                        step: stepIndex,
                                        byo_variant: itemData?.legacyId || '',

                                        interaction_type: 'add_item',
                                        byo_step: stepIndex,
                                        byo_item_name: itemData?.name,
                                        byo_item_variant: itemData?.legacyId,
                                        byo_item_quantity: numberSelected,
                                    }));
                                }}
                                disabled={disabled}
                            >
                                Add to Gift
                            </button>
                        )}
                    <span
                        className={style.giftSizeName}
                        onKeyDown={() => { }}
                        tabIndex={-1}
                        role="button"
                        onClick={(e) => {
                            handlePopup(e, itemData);
                        }}
                    >
                        {ReactHtmlParser(itemData?.name)}
                    </span>
                </div>
            </div>

        </>
    );
};

BYOItemsSelected.propTypes = {
    handleItemSelection: func.isRequired,
    itemData: object.isRequired,
    numberSelected: number.isRequired,
    disabled: bool.isRequired,
    setSelectedOption: func.isRequired,
    setOpen: func.isRequired,
    error: string.isRequired,
    handleRemoveError: func.isRequired,
    isCYOQtyButtonEnabled: bool,
    stepIndex: string,
};
BYOItemsSelected.defaultProps = {
    isCYOQtyButtonEnabled: false,
    stepIndex: null,
};
export default BYOItemsSelected;
